import React from "react";
import styles from "@src/components/helpers.module.scss";
import { IIconActiveProps } from "./helpers";

export const AutoPoIcon: React.FC<IIconActiveProps> = ({ isActive }) => {
	return (
		<div className={styles.iconContainer}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke={isActive ? "var(--activeIcon)" : "var(--inactiveIcon)"}
				strokeWidth={1.6}
				strokeLinecap="round"
				strokeLinejoin="round">
				{/* page + folded corner */}
				<path d="M14 2 H6 a2 2 0 0 0 -2 2 V20 a2 2 0 0 0 2 2 H12.3" />
				<path d="M20 8V13.3" />
				<path d="M14 2v6h6M14 2l6 6" />
				{/* text lines */}
				<line x1="8" y1="13" x2="13" y2="13" />
				<line x1="8" y1="17" x2="11" y2="17" />
				{/* refresh arrow (overhangs bottom-right) */}
				<path d="M21.5 19a3.5 3.5 0 1 1 -1.025 -2.475" />
				<path d="M21.5 15.5v2.333h-2.333" />
			</svg>
		</div>
	);
};
